var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaIzquierdaActivo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30853 11.7071C7.16408 11.8757 7.16408 12.1243 7.30853 12.2928L12.6391 18.5119C12.9087 18.8264 12.8723 19.2999 12.5578 19.5694C12.2433 19.839 11.7698 19.8026 11.5003 19.4881L6.16965 13.269C5.54371 12.5388 5.54371 11.4612 6.16965 10.7309L11.5003 4.51189C11.7698 4.1974 12.2433 4.16098 12.5578 4.43054C12.8723 4.70011 12.9087 5.17359 12.6391 5.48808L7.30853 11.7071Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8197 12C5.8197 12.4142 6.15549 12.75 6.5697 12.75H19.0697C19.4839 12.75 19.8197 12.4142 19.8197 12C19.8197 11.5858 19.4839 11.25 19.0697 11.25H6.5697C6.15549 11.25 5.8197 11.5858 5.8197 12Z",
    fill: "CurrentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzquierdaActivo);
export default __webpack_public_path__ + "static/media/FLECHA_IZQUIERDA_ACTIVO.7723e2d5ea9d582af825b2065ad3f3a4.svg";
export { ForwardRef as ReactComponent };